"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const spacing = {
  "6x": "3rem",
  "5x": "2.5rem",
  "4x": "2rem",
  "3x": "1.5rem",
  "2point5x": "1.25rem",
  "2x": "1rem",
  "1x": "0.5rem",
  "0point5x": "0.25rem",
  "0point25x": "0.125rem"
};
exports.default = spacing;